import React from 'react';
import PropTypes from 'prop-types';

import texts from '../texts';
import {
  TooltipRow,
  TooltipLabel,
  TooltipHeader,
} from './styles';

const FeesInfoTooltip = ({ meta }) => {
  const { previousValue, newValue } = meta;

  const formatFee = (val) => (val?.value !== undefined ? `${val.value}%` : texts.naText);

  const rows = [
    {
      label: texts.feeLabels.baseFee,
      before: formatFee(previousValue?.baseFee),
      after: formatFee(newValue?.baseFee),
    },
    {
      label: texts.feeLabels.insideSalesFee,
      before: formatFee(previousValue?.insideSalesFee),
      after: formatFee(newValue?.insideSalesFee),
    },
    {
      label: texts.feeLabels.assistantCoachFee,
      before: formatFee(previousValue?.assistantCoachFee),
      after: formatFee(newValue?.assistantCoachFee),
    },
  ];

  return (
    <div>
      <TooltipHeader>
        <TooltipLabel />
        <span>{texts.changeTexts.before}</span>
        <span>{texts.changeTexts.after}</span>
      </TooltipHeader>
      {rows.map(({ label, before, after }) => (
        <TooltipRow key={label}>
          <TooltipLabel>{label}</TooltipLabel>
          <span>{before}</span>
          <span>{texts.arrowIcon}</span>
          <span>{after}</span>
        </TooltipRow>
      ))}
    </div>
  );
};

FeesInfoTooltip.propTypes = {
  meta: PropTypes.shape({
    previousValue: PropTypes.object,
    newValue: PropTypes.object,
  }).isRequired,
};

export default FeesInfoTooltip;
